import { z } from "zod";

const errorClass = 'error';

export const initalisePrefooter = () => {
    const form = document.querySelector('.js-prefooter-newsletter form');
    if (!form) {
        return;
    }

    const emailSet = form.querySelector('.js-email-set');
    if (!emailSet) {
        return;
    }

    const emailInput = emailSet.querySelector('.js-email-input');
    if (!emailInput) {
        return;
    }

    const isEmailValid = () => {
        const formData = new FormData(form);
        const email = formData.get("cm-ttdlkt-ttdlkt");
        const emailSchema = z.string().email();
        const result = emailSchema.safeParse(email);
        return result.success;
    }

    const toggleErrorClasses = (valid) => {
        if (!valid) {
            emailSet.classList.add(errorClass);
        } else {
            emailSet.classList.remove(errorClass);
        }
    }

    form.addEventListener('submit', (event) => {
        const valid = isEmailValid();
        toggleErrorClasses(valid);
        if (!valid) {
            event.preventDefault();
        }
    });

    emailInput.addEventListener('input', () => {
        if (emailSet.classList.contains(errorClass)) {
            const valid = isEmailValid();
            toggleErrorClasses(valid);
        }
    });
}